<template>
    <div>
      <RouterLink
        class="action"
        :to="{ name: 'report.model', params: { modelId: model.id } }"
      >
        <div class="icon"></div>
        <div class="container">
          <div class="title">
            <span>
              {{ $t('webstars.buttons.report.title').toUpperCase() }}
            </span>
          </div>
          <div class="description">
            <small>
              {{ $t('webstars.buttons.report.subtitle') }}
            </small>
            <img src="/img/payment_methods/visa-black.png" class="card" />
            <img src="/img/payment_methods/mastercard-black.png" class="card" />
          </div>
        </div>
      </RouterLink>
    </div>
</template>
<script>
export default {
  props: {
    model: {
      type: Object,
      required: true
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.action {
  display: flex;
  flex-direction: row;
  width: 300px;
  min-height: 50px;
  text-align: center;
  background: #dedfe2;
  cursor: pointer;
  margin-bottom: 5px;
  overflow: hidden;
  font-weight: 600;
  
  .icon {
    width: 80px;
    // height: 50px;
    // background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: var(--img-btn-warn);
    background-color: var(--pallete_img_btn_warn_background);
  }

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 220px;

    .title {
      max-width: 95%;
      width: 220px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      overflow: hidden;
      font-size: .9em;
    }

    .description {
      width: 220px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      overflow: hidden;
      
      small{
        font-size: .7em;
      }

      .card {
        height: 1.7em;
        margin-left: 0.25em;
        
        &:first-of-type {
          margin-left: 0.5em;
        }
      }
    }
  }
  
}
.chat-subtitle-username {
  color: var(--pallete_main_color);
}
</style>
